import React from "react";
import BillingStatusStyle from "./BillingStatusStyle.module.scss";
import HourglassFullIcon from '@mui/icons-material/HourglassFull';
import { Grid2 } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
function BillingStatus(props) {
    const { status } = props;
  
    let icon, text, statusClass;
  
    if (status === "intialized" || status === "pending") {
      icon = <HourglassFullIcon className={BillingStatusStyle.icon} />;
      text = "Pending";
      statusClass = BillingStatusStyle.pending; 
    } else if (status === "paid") {
      icon = <CheckCircleIcon className={BillingStatusStyle.icon} />;
      text = "Done";
      statusClass = BillingStatusStyle.done;
    }
  
    return (
      <Grid2 className={`${BillingStatusStyle.container} ${statusClass}`}>
        {icon}
        <span className={BillingStatusStyle.text}>{text}</span>
      </Grid2>
    );
  }
  
  export default BillingStatus;